"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRecordToKVCollection = exports.convertMetaToKVCollection = void 0;
function convertMetaToKVCollection(meta) {
    var e_1, _a;
    var collection = [];
    var _loop_1 = function (key, value) {
        if (!isValidValueType(value)) {
            if (process.env.NODE_ENV !== 'prodction' && process.env.NODE_ENV !== 'test') {
                console.warn('Ошибка! Не допустимый тип значения у мета информации.\n' +
                    ("\u041A\u043B\u044E\u0447: \"" + key + "\", \u0442\u0438\u043F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F: \"" + typeof value + "\"\n") +
                    'Данное поле будет исключено из лога и не попадет в ELK.');
            }
            return "continue";
        }
        if (value !== null && !Array.isArray(value) && typeof value === 'object') {
            collection.push.apply(collection, __spread(convertRecordToKVCollection(value, key)));
        }
        else {
            if (Array.isArray(value)) {
                var arrIsInvalid_1 = false;
                value.forEach(function (val) {
                    if (!isValidValueType(val)) {
                        arrIsInvalid_1 = true;
                        if (process.env.NODE_ENV !== 'prodction' && process.env.NODE_ENV !== 'test') {
                            console.warn('Ошибка! Не допустимый тип значения у мета информации.\n' +
                                ("\u041A\u043B\u044E\u0447: \"" + key + "\", \u0442\u0438\u043F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F: \"" + typeof val + "\"\n") +
                                'Данное поле будет исключено из лога и не попадет в ELK.');
                        }
                    }
                });
                if (arrIsInvalid_1) {
                    return "continue";
                }
            }
            collection.push({ key: key, value: value });
        }
    };
    try {
        for (var _b = __values(Object.entries(meta)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            _loop_1(key, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return collection;
}
exports.convertMetaToKVCollection = convertMetaToKVCollection;
function convertRecordToKVCollection(record, preffix) {
    var e_2, _a;
    var collection = [];
    try {
        for (var _b = __values(Object.entries(record)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), partOfKey = _d[0], value = _d[1];
            var key = preffix + "." + partOfKey;
            if (!isValidValueType(value)) {
                if (process.env.NODE_ENV !== 'prodction' && process.env.NODE_ENV !== 'test') {
                    console.warn('Ошибка! Не допустимый тип значения у мета информации.\n' +
                        ("\u041A\u043B\u044E\u0447: \"" + key + "\", \u0442\u0438\u043F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F: \"" + typeof value + "\"\n") +
                        'Данное поле будет исключено из лога и не попадет в ELK.');
                }
                continue;
            }
            if (value !== null && !Array.isArray(value) && typeof value === 'object') {
                if (process.env.NODE_ENV !== 'prodction' && process.env.NODE_ENV !== 'test') {
                    console.warn('Ошибка! Типы значений вложенного json-объекта должны быть примитивами или массивом примитивов\n' +
                        ("\u041A\u043B\u044E\u0447: \"" + key + "\", \u0442\u0438\u043F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F: \"" + typeof value + "\"\n") +
                        'Данное поле будет исключено из лога и не попадет в ELK.');
                }
                continue;
            }
            else {
                collection.push({ key: key, value: value });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return collection;
}
exports.convertRecordToKVCollection = convertRecordToKVCollection;
function isValidValueType(value) {
    switch (typeof value) {
        case 'bigint':
        case 'boolean':
        case 'number':
        case 'object':
        case 'string':
        case 'undefined':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=ExceptionData.js.map